import { useEffect, useState } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import useInputState from "../../../hooks/useInputState";
import { GetAccountPreference } from "../queries";
import { UpdateAccountPreference } from "../ThemeSettings/mutation";
import DefaultToaster from "../../../atoms/DefaultToaster";
import { Intent } from "@blueprintjs/core";
import { replaceIndex, addIndex } from "../../../helpers/JSONTransformations";

export function useProgramHighlights() {
  const [rows, setRows] = useState([""]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [programHighlight, setProgramHighlight] = useInputState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState();
  const { data, loading } = useQuery(GetAccountPreference);
  const [updateAccountPreference] = useMutation(UpdateAccountPreference, {
    refetchQueries: [{ query: GetAccountPreference }]
  });

  const onChangeInput = (rowIndex) => ({ target: { value } }) => {
    setRows(replaceIndex(rows, rowIndex, value));
  };
  const addRow = (rowIndex) => {
    setRows(addIndex(rows, rowIndex, ""));
  };
  const deleteRow = (rowIndex) => {
    rows.length !== 1 && setRows(rows.filter((row, i) => i !== rowIndex));
  };

  const account = data && data.accounts && data.accounts[0];

  const preference = account && account.preference;

  const prefillData = (preference) => {
    let programFeatures = JSON.parse(preference.programFeatures);
    setRows(programFeatures.length ? programFeatures : [""]);
    setProgramHighlight(preference.programHighlight);
  };

  useEffect(() => {
    preference && prefillData(preference);
  }, [preference]);

  const onCancel = () => {
    if (preference) {
      prefillData(preference);
    } else {
      setRows([""]);
      setProgramHighlight("");
    }
    DefaultToaster.show({
      message: "Form restored to original state successfully!",
      icon: "tick",
      intent: Intent.SUCCESS
    });
  };

  const saveChanges = async (e) => {
    e.preventDefault();
    let hasEmptyRow = rows.some((row) => !row.trim());
    if (hasEmptyRow) {
      setError({ message: "Brand checklist can not have an empty row" });
      return;
    }

    setIsSaving(true);
    setError(undefined);

    const {
      data: { updateAccountPreference: status }
    } = await updateAccountPreference({
      variables: {
        preference: {
          programFeatures: JSON.stringify(rows),
          programHighlight
        }
      }
    });
    setIsSaving(false);
    if (status == "Updated") {
      DefaultToaster.show({
        message: "Program Highlights updated!",
        icon: "tick",
        intent: Intent.SUCCESS
      });
    } else {
      setError({ message: "An error occurred while updating the record." });
    }
  };

  return {
    account,
    rows,
    onChangeInput,
    addRow,
    deleteRow,
    programHighlight,
    setProgramHighlight,
    saveChanges,
    onCancel,
    loading,
    error,
    isSaving,
    isSaveEnabled: !isSaving && programHighlight,
    isPreviewOpen,
    setIsPreviewOpen,
    isPreviewReady:
      !!programHighlight && rows.filter((row) => !!row.trim()).length > 0
  };
}
